import { Component, OnInit } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { PaymentService } from '../../services/payment.service';
import { Timestamp } from 'firebase/firestore';
import { CommonModule, DecimalPipe } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-payments',
  imports: [DecimalPipe,CommonModule],
  templateUrl: './payments.component.html',
  styleUrl: './payments.component.scss',
})
export class PaymentsComponent implements OnInit {
  payments$!: Observable<any[]>;
previewPaymentId: string | null = null;
  constructor(
    private auth: AuthService,
    private paymentService: PaymentService,
  private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    const uid = this.auth.firebaseUid;
    this.payments$ = this.paymentService.getPaymentsByTenant(uid).pipe(
      map(payments =>
        payments.map(p => {
          const date = this.normalizeDate(p.createdAt);
          const amountinCents = p.amount / 100;
          return {
            ...p,
            amountinCents,
            createdAtFormatted: this.formatDate(date),
          };
        })
      )
    );
  }
  getSafeReceiptUrl(url: string): SafeResourceUrl {
  return this.sanitizer.bypassSecurityTrustResourceUrl(url);
}

private normalizeDate(input: any): Date | null {
    if (!input) return null;

    // Firestore Timestamp
    if (input instanceof Timestamp) return input.toDate();

    // Number timestamp
    if (typeof input === 'number') return new Date(input);

    // String timestamp (e.g. "November 18, 2025 at 1:30:06 PM UTC")
    if (typeof input === 'string') return new Date(input);

    // Fallback
    return null;
  }
  // Track Payment By ID (Optimization for ngFor)
  trackPayment(index: number, payment: any): string {
    return payment.id;
  }
  private formatDate(date: Date | null): string {
    if (!date) return '';

    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'long' });
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');

    // AM/PM formatting
    const period = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;

    // Ordinal suffix (1st, 2nd, 3rd, 4th, 11th, 12th...)
    const suffix =
      day >= 11 && day <= 13
        ? 'th'
        : ['st', 'nd', 'rd'][((day % 10) - 1)] || 'th';

    return `${month} ${day}${suffix}, ${year} ${hour12}:${minutes} ${period}`;
}
   downloadReceipt(url: string) {
    window.open(url, '_blank', 'noopener');
  }
  payments: any[] = [];
lastDoc: any = null;
loading = false;

async loadMore() {
  if (this.loading) return;
  this.loading = true;

  const uid = this.auth.firebaseUid!;
  const res = await firstValueFrom(
    this.paymentService.getPaymentsPage(uid, 10, this.lastDoc)
  );

  this.payments.push(...res.payments);
  this.lastDoc = res.lastDoc;
  this.loading = false;
}
}

